import { useShallow } from 'zustand/react/shallow';

import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { resolveWebviewEntry } from '@/utils/resolveWebviewEntry';

/**
 * api에 entry를 간편히 보내기 위한 훅\
 * TOSS 또는 KB_PAY에서 왔을 경우 다른 데이터를 보여주기 위한 목적으로 사용
 */
export const useWebviewTypeEntry = () => {
  const [subDomain, webviewType] = useDeviceInfoStore(
    useShallow((state) => [state.subDomain, state.webviewType] as const),
  );

  return {
    entry: resolveWebviewEntry(subDomain, webviewType),
    //* hydrate 첫 렌더는 서버 스냅샷(subDomain undefined)이라 entry가 WELLO로 보인다 — 쿼리는 판정 뒤에 건다
    isEntryResolved: subDomain !== undefined,
  };
};
